import { FRAXLEND_PAIR_ABI } from '@/config/abis/FraxlendPair.abi'
import { ensureConfigTypes } from '@/domain/hooks/useWrite'
import { getPortfolioBalanceInvalidationKeys } from '@/features/actions/logic/invalidation'
import { toBigInt } from '@/utils/bigNumber'
import { ActionConfig, ActionContext } from '../../../logic/types'
import { IsolatedWithdrawAction } from '../types'

export function createIsolatedWithdrawActionConfig(
  action: IsolatedWithdrawAction,
  context: ActionContext,
): ActionConfig {
  const { account, chainId, isolatedInfo } = context

  return {
    getWriteConfig: () => {
      const withdrawAmount = toBigInt(action.token.toBaseUnit(action.value))

      return ensureConfigTypes({
        abi: FRAXLEND_PAIR_ABI,
        address: action.pairAddress ?? isolatedInfo?.pairAddress,
        functionName: 'removeCollateral',
        chainId,
        args: [withdrawAmount, account],
      })
    },

    invalidates: () => getPortfolioBalanceInvalidationKeys({ account, chainId }),
  }
}
